import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el CROSSFIT RESUELTO después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un email con el link de descarga de todos los PDFs. Acceso en menos de 5 minutos, desde cualquier dispositivo.'
}, {
  q: '¿Sirve para instructores con poca experiencia o solo para los avanzados?',
  a: 'Sirve para ambos. Los tomos están estructurados desde la base hasta el nivel avanzado. Si empezás, te da el sistema que necesitás para arrancar bien. Si ya tenés experiencia, te organiza y profesionaliza lo que ya sabés.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'Es un PDF de uso personal. Podés usarlo, imprimirlo y aplicarlo libremente en tus clases. No está habilitada la edición ni la redistribución.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos están incluidos en ambas ofertas sin costo adicional. La diferencia del Pack Completo son los 2 módulos del Crossfit Pro™.'
}, {
  q: '¿Sirve si doy clases individuales o solo para grupos?',
  a: 'Sirve para los dos. Todo el sistema tiene versión grupal e individual. Los protocolos de evaluación y seguimiento son especialmente útiles para el trabajo personalizado.'
}, {
  q: '¿Sirve si tengo alumnos de distintos niveles al mismo tiempo?',
  a: 'Especialmente para eso. El Tomo 3 está diseñado exactamente para esa situación. Cada WOD tiene 3 versiones y el sistema de escalado te permite manejar un grupo heterogéneo sin caos.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de Crossfit?',
  a: 'Es el único sistema en español diseñado específicamente para instructores de crossfit en Argentina. No es contenido genérico de fitness. Es terminología real del crossfit, cargas en kg, contexto latinoamericano y recursos listos para usar hoy en tu box.'
}, {
  q: '¿Por qué elegir el Pack Completo y no el estándar?',
  a: 'Si tenés alumnos con alguna condición médica o historial de lesiones, el Crossfit Pro™ te da la seguridad y el profesionalismo que el producto estándar no cubre. La mayoría de los instructores con más de 20 alumnos lo elige porque en algún momento aparece un alumno con patología.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días con devolución del 100% sin preguntas. Podés abrir todos los PDFs, usarlos en clase y si no es lo que esperabas te devolvemos todo. Así de simple.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-24 px-4 bg-cf-dark border-t border-white/5" data-id="element-192">
      <div className="max-w-3xl mx-auto" data-id="element-193">
        <h2 className="font-bebas text-3xl md:text-6xl text-center text-white tracking-tight mb-8 md:mb-12" data-id="element-194">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 md:space-y-4" data-id="element-195">
          {faqs.map((faq, i) => <div key={i} className="bg-cf-card border border-white/10 rounded-lg overflow-hidden" data-id="element-196">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 md:px-6 py-4 md:py-5 text-left flex justify-between items-center hover:bg-white/5 transition-colors gap-3" data-id="element-197">
                <span className="font-bold text-sm md:text-lg text-white" data-id="element-198">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-cf-gold flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-199" />
              </button>
              <AnimatePresence data-id="element-200">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-201">
                    <div className="px-4 md:px-6 pb-5 md:pb-6 text-sm md:text-base text-gray-300 border-t border-white/5 pt-4" data-id="element-202">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}